import { useQuery } from "@tanstack/react-query"

import type { EgressDiagnosticsResponse } from "@/api/admin-api"

import { getEgressDiagnostics } from "@/api/admin-api"

// Egress proxy diagnostics (#2645). On-demand only: the checks make real
// outbound requests (proxied + direct probes), so no auto-refresh interval —
// the card triggers refetch() explicitly.
export function useEgressDiagnosticsQuery(enabled: boolean) {
  return useQuery<EgressDiagnosticsResponse>({
    queryKey: ["admin", "egress-diagnostics"],
    queryFn: getEgressDiagnostics,
    enabled,
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: false,
  })
}
